var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13126 14.625H31.5C32.1213 14.625 32.625 14.1213 32.625 13.5C32.625 12.8787 32.1213 12.375 31.5 12.375H6.13126C5.50994 12.375 5.00626 12.8787 5.00626 13.5C5.00626 14.1213 5.50994 14.625 6.13126 14.625Z",
    fill: "#232360"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1433 30.1731C19.1312 30.2395 19.125 30.3075 19.125 30.375L19.1251 30.3914C19.1284 30.6146 19.198 30.8318 19.325 31.0154C19.4949 31.2607 19.7552 31.4285 20.0488 31.4819C20.1152 31.4939 20.1825 31.5 20.25 31.5L20.2535 31.5C20.7959 31.4983 21.2598 31.1099 21.3569 30.5762L25.8569 5.82625C25.8689 5.75984 25.875 5.69249 25.875 5.625L25.8749 5.60859C25.8716 5.38538 25.802 5.16818 25.675 4.98464C25.5051 4.73932 25.2448 4.57152 24.9512 4.51815C24.8848 4.50607 24.8175 4.5 24.75 4.5L24.7465 4.50001C24.2041 4.5017 23.7402 4.89013 23.6431 5.42375L19.1433 30.1731Z",
    fill: "#232360"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1433 30.1731C10.1312 30.2395 10.125 30.3075 10.125 30.375L10.1251 30.3914C10.1284 30.6146 10.198 30.8318 10.325 31.0154C10.4949 31.2607 10.7552 31.4285 11.0488 31.4819C11.1152 31.4939 11.1825 31.5 11.25 31.5L11.2535 31.5C11.7959 31.4983 12.2598 31.1099 12.3569 30.5762L16.8569 5.82625C16.8689 5.75984 16.875 5.69249 16.875 5.625L16.8749 5.60859C16.8716 5.38538 16.802 5.16818 16.675 4.98464C16.5051 4.73932 16.2448 4.57152 15.9512 4.51815C15.8848 4.50607 15.8175 4.5 15.75 4.5L15.7465 4.50001C15.2041 4.5017 14.7402 4.89013 14.6431 5.42375L10.1433 30.1731Z",
    fill: "#232360"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 23.625H29.8687C30.4901 23.625 30.9937 23.1213 30.9937 22.5C30.9937 21.8787 30.4901 21.375 29.8687 21.375H4.5C3.87868 21.375 3.375 21.8787 3.375 22.5C3.375 23.1213 3.87868 23.625 4.5 23.625Z",
    fill: "#232360"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/Hash.0e772d026ad8b8dab9f0e3305822b3e0.svg";
export { ForwardRef as ReactComponent };